export enum StatusJornada{
  NaoIniciada = 0,
  Iniciada = 1,
  EmAndamento = 2,
  Finalizada = 3,
  ComErro = 4
}
